<div class="matched-xray">
  <div class="matched-xray-section">
    <div class="text-danger heading">
      Multiple X-Ray Images Uploaded
      <span class="badge bg-danger">{{ studyFiles.length }}</span>
    </div>

    <div class="row">
      <ng-container
        *ngFor="
          let mediaGroup of mediaGroups
            | filterGroupsWithStudiesPipe : studyFiles;
          trackBy: identifyGroup
        "
      >
        <ng-container
          *ngFor="
            let mediaCategory of mediaGroup.mediaCategories;
            trackBy: identifyCategory
          "
        >
          <div
            *ngIf="mediaCategory.studyFiles.length"
            class="xray-wrapper col-md-{{
              mediaCategory.studyFiles.length <= 6
                ? mediaCategory.studyFiles.length * 2
                : 12
            }}"
          >
            <div class="group-wrapper">
              <span class="badge type media-group-name w-100 mb-4">{{
                mediaCategory?.mediaCategory?.name
              }}</span>
              <div class="row">
                <div
                  *ngFor="
                    let studyFile of mediaCategory.studyFiles
                      | sortStudiesByCategoryPipe;
                    trackBy: identifyStudyFile
                  "
                  [class.col-md-6]="mediaCategory.studyFiles.length === 2"
                  [class.col-md-4]="mediaCategory.studyFiles.length === 3"
                  [class.col-md-3]="mediaCategory.studyFiles.length === 4"
                  [class.col-md-2]="mediaCategory.studyFiles.length > 4"
                >
                  <app-xray-item
                    [studyFile]="studyFile"
                    [mediaCategories]="mediaCategories"
                    [mediaGroups]="mediaGroups"
                    [isDuplicate]="true"
                    (changeCategoryClicked)="emitChangeMediaCategory($event)"
                    (uploadAdditionalClicked)="emitUploadAsAdditional($event)"
                    (deleteStudyFileClicked)="emitDeleteStudyFile($event)"
                    (useImageClicked)="
                      emitUseImage($event, mediaCategory.studyFiles)
                    "
                  ></app-xray-item>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
